var FeedbackFormatter = require("lib/interface/FeedbackFormatter");
var Glyphicon = require("components/utility/icons/Glyphicon");
var Spinner = require("components/utility/Spinner");
var ReactionFeedback = require("components/support/ReactionFeedback");
var FeedbackFormatter = require("lib/interface/FeedbackFormatter");
var CurrentUser = require("lib/account/CurrentUser");
var Carousel = require("components/utility/Carousel");
var TextAreaMarkups = require("components/writing/evaluations/TextAreaMarkups");
var QuestionFeedback = require("components/writing/questions/QuestionFeedback");
var AutograderDisplayConfig = require("lib/interface/AutograderDisplayConfig");

var SpeechControls = require("components/writing/questions/SpeechControls");

var CSSTransition = require("react-transition-group/CSSTransition");
var TransitionGroup = require("react-transition-group/TransitionGroup");


require("writing/quizzes/quiz_analysis_display.scss");

class QuizAnalysisDisplay extends React.Component {
	constructor(props) {
		super();
		autobind(this);
		var speechControlSetting = CurrentUser.get().prefs.speech_controls;
		this.state = {
			"analysis": null,
			"Strengths": 1,
			"Weaknesses": 1,
			"owlfonsoShow": true,
			"viewed": ["Strengths-0", "Weaknesses-0"],
			"speechControlSetting": speechControlSetting
		};
	}

	////////////////
	////////////
	////////
	////
	// FIRST RENDER OWLFONSO

	renderOwlfonso() {
		if (this.state.owlfonsoShow) {
			var text = "Hi " + CurrentUser.get().first_name + ",\n\n here is how you did on your quiz!"
			return (
				<CSSTransition classNames="owlfonso-animation"
					timeout={{ enter: 2500, exit: 5000 }}>
					<QuestionFeedback ref={ "owlfonso" } feedbackItems={ [text] } />
				</CSSTransition>
			)
		} else {
			return ""
		}
	}
	removeOwlfonso() {
		if (this.state.speechControlSetting == "voice-first") {
			var timeout = 5500
		} else {
			var timeout = 3000
		}
		setTimeout(function(){
			this.setState({owlfonsoShow:false},this.triggerChainDisplay.bind(this,">"))
		}.bind(this),timeout)
	}

	////////////////
	////////////
	////////
	////
	// SECOND RENDER FEEDBACK CONTENT

	getCategory(cat) {
		if (this.state.analysis[cat].length > 0) {
			if (cat == "Strengths") {
				var colorClass = " valid"
				var catName = "Well Done"
				var icon = "glyphicon-ok-sign"
			} else {
				var colorClass = " error"
				var catName = "Could Improve"
				var icon = "glyphicon-exclamation-sign"

			}

			var descriptions = this.state.analysis[cat].map(function(item,i){
				var description = item.description
				var title = item.title
				function getTextToRead() {
					return catName + "\n" + title + "\n" + description
				}
				if (this.state.speechControlSetting == "voice-first") {
					var speechControl = <SpeechControls key={cat} getTextToRead={ getTextToRead } autoReadText={ true } readTextOnly={true}/>
				} else if (this.state.speechControlSetting == "normal") {
					var speechControl = <SpeechControls key={cat} getTextToRead={ getTextToRead } autoReadText={ false } readTextOnly={true}/> 
				}
				var feedbackContainer = this.renderOverriddenFeedbackDisclaimer(item)
				var asktrisk = feedbackContainer ? '*' : ''
				return (
					<div key={i}>
						<div className="feedbackDescription">
							<div className="feedbackTitle">
								<Glyphicon className={colorClass} icon={ "glyphicon "+icon } />
								<span className="titleContent">{catName}: {title}{asktrisk}</span>
								{ speechControl }
							</div>
							{ FeedbackFormatter.format(description) }
						</div>
						{ this.renderIndividualExamplesDisplay(cat, i) }
						{feedbackContainer }
					</div>
				)
			}.bind(this))
			if (this.refs["carousel_"+cat]) {
				var index = this.refs["carousel_"+cat].state.displayIndex
			} else {
				var index = 1
			}
			return (
				<div className="categoryDisplay">
					<div className="feedbackContent">
						<Carousel onIndexChange={this.carouselChange.bind(this,cat)} displayItems={ descriptions } />
						<div className="carouselFooter">
							<span className={"badge" + colorClass + "Background"}> 
								{this.state[cat]}/{this.state.analysis[cat].length}
							</span> 
						</div>
					</div>
				</div>
			)
		} else {
			return ""
		}
	}

	////////////////
	////////////
	////////
	////
	// THIRD RENDER EXAMPLE CONTENT

	renderIndividualExamplesDisplay(category,index) {
		var activeData = this.state.analysis[category][index]
		if (!activeData) {
			return <div className="emptyExample" />
		}

		return (
			<div className="individualExamples">
				{ this.dividerWithTitle("Example") }
				{ this.renderBestExample(activeData.example) }
			</div>
		);
	}

	// pulls overridden words from answer meta_data
	pullOverriddenWords() {
		var overriddenWords = []
		if (this.state.answers) {
			overriddenWords =_.map(this.state.answers, (answer) => {
				if (answer.meta_data) {
					var metaDataArray = _.where(answer.meta_data, { feedback_key: "WRITE_GRAM_SPELLING" })
					return _.map(metaDataArray, meta_data => { return meta_data.trigger })
				}
			})
			overriddenWords = _.uniq(_.compact(_.flatten(overriddenWords)))
		}
		return overriddenWords
	}


	// determins if feedback has been overridden and displays disclaimer if so
	renderOverriddenFeedbackDisclaimer(item) {
		if (item.title === SPELLING) {
			var overriddenWords = this.pullOverriddenWords()
			if (overriddenWords) {
				var givenAnswer = item.example.corrected_answer
				var overriddenWords = overriddenWords
				var spans = []
				for (var key in item.example.tags) {
					spans = [...spans, item.example.tags[key][0].spans]
				}
				var highlightedWords = _.map(spans, (span) => {
					var charNumber = span[0].end - span[0].start
					return givenAnswer.substr(span[0].start, charNumber)
				})
				highlightedWords = _.uniq(highlightedWords)
				var overriddenAndHighlighted = _.compact(_.map(highlightedWords, (word) => {
					if (overriddenWords.includes(word)) {
						return word
					}
				}))
				if (overriddenAndHighlighted.length === 1) {
					return (<div className='overriddenDisclaimer'><strong>* You marked "{_.first(overriddenAndHighlighted)}" as spelled correctly</strong></div>)
				} else if (overriddenAndHighlighted.length ==2) {
					return (<div className='overriddenDisclaimer'><strong>* You marked "{overriddenAndHighlighted[0]}" and "{overriddenAndHighlighted[1]}" as spelled correctly</strong></div>)
				} else if (overriddenAndHighlighted.length > 1) {
					var textValues = ''
					_.each(overriddenAndHighlighted, (text, i) => {
						if (i === overriddenAndHighlighted.length - 1) {
							textValues = `${textValues} and ${text}`
						} else {
							textValues = `${text}, `
						}
					})
					return (<div className='overriddenDisclaimer'><strong>* You marked "{textValues}" as spelled correctly</strong></div>)
				}
			}
		}
	}
	selectBestExample(examples) {
		var selected_examples = _.select(examples, (example) => example.answer )
		if (selected_examples.length > 0) {
			selected_examples.sort(function(a,b){
				return a.markups.length < b.markups.length;
			})
			return selected_examples[0];
		} else {
			return null;
		}
	}
	fetchAnswerByID(id) {
		for (var i=0;i<this.props.quiz.answers.length;i+=1) {
			if (this.props.quiz.answers[i].id == id){
				return this.props.quiz.answers[i]
			}
		}
		return null
	}
	renderBestExample(example) {
		if (example) {
			var tagColors = pickTagColors(example.tags);
			return (
				<div key={ 0 } className="singleExample">
					<p><strong>{ example.question_text }</strong></p>
					<TextAreaMarkups text={ example.corrected_answer }
							tagging={ example.tags } tagColors={ tagColors } />
				</div>
			);
		}
	}
	dividerWithTitle(titleText) {
		return (
			<div className="dividerWithTitle">
				<div className="dividerArea"></div>
				<div className="titleArea">
					{ titleText }
				</div>
			</div>
		);
	}

	////////////////
	////////////
	////////
	////
	// HANDLE CAROUSEL CHANGE AND REWARD

	getViewCount() {
		var count = 0
		Object.keys(this.state.analysis).forEach(function(key) {
			count += this.state.analysis[key].length
		}.bind(this))
		return count
	}
	shouldReward() {
		if (this.state.viewed.length >= this.getViewCount() && !this.state.reviewComplete) {
			var params = {
				award: {
					type: "qunit", key:"reviewed-post-quiz-feedback",
					"dynamic": {
						"subject_type": "quiz",
						"subject_id": this.props.quiz.id
					}, 
					student_id: CurrentUser.get().id 
				}
			};
			this.setState({reviewComplete:true})
			 CurrentUser.api().postAwards(params, $wr.apiHandler (function(response) {
	            window.wrNotifications.triggerDropDownNotification({
							title: "Reviewed feedback!", text: "Well done reviewing all feedback items for this question!", icon: "ok-circle"});
	        	CurrentUser.fetchCurrentUserCoinData();
	        }.bind(this)));
		}
	}
	carouselChange(ref,index) {
		var newStates = {}
		var newViewed = this.state.viewed.slice()
		newStates[ref] = index + 1
		var viewString = ref + "-" + index
		if (!newViewed.includes(viewString)) {
			newViewed.push(viewString)
			newStates["viewed"] = newViewed
		}

		this.setState(newStates,this.shouldReward)

	}
	////////////////
	////////////
	////////
	////
	// DISPLAY AND FEEDBACK

	triggerChainDisplay(dynamicDisplayClass) {
		var refs = Object.keys(this.refs).filter(function(key){if(key.includes(dynamicDisplayClass)){return 1} else {return 0}})
		if (refs.length > 0) {
			var index = 0;
			refs.sort();
			function showNext() {
				index += 1
				if (index < refs.length) {
					$( this.refs[refs[index]]).show( this.props.delay, showNext.bind(this) );
				} else {
					if (this.props.showCoinTable) {
						this.props.showCoinTable()
					}
				}
			}
			$(this.refs[refs[index]]).show( this.props.delay,showNext.bind(this) );
		}
	}
	
	buildReactionFeedback() {
		var reactionDetails = {}
		reactionDetails[ReactionFeedback.HAPPY] = { label: "Great!" };
		reactionDetails[ReactionFeedback.NEUTRAL] = { label: "Not quite..." };
		reactionDetails[ReactionFeedback.SAD] = { label: "Completely wrong!" };
		
		var subjectType = "quiz"
		var subjectID = this.props.quiz.id

		var reactionWhere = "component-post-quiz-feedback-" + subjectType 

		return <ReactionFeedback where={ reactionWhere }
								key={ reactionWhere } 
	  							textOnly={ false }
	  							options={ reactionDetails }
	    						title={ "Was this helpful?" }
	    						placeholder={"Help us improve our scoring by telling us why..."}
		   						component_position = { ReactionFeedback.POSITION_BOTTOM_RIGHT }
		   						popover_position={ ReactionFeedback.POSITION_BOTTOM_RIGHT }
		   						subjectType={subjectType}
		   						subjectID={ subjectID }
	    					/>
	}

	////////////////
	////////////
	////////
	////
	// RENDER

	render() {
		if (!this.state.owlfonsoShow) {
			if (this.state.analysis) {
				var strongFeedback = this.getCategory('Strengths')
				var weakFeedback = this.getCategory('Weaknesses')
				var content = (
		        	<CSSTransition classNames="feedback-animation"
						timeout={{ enter: 3000, exit: 1000 }}>
						<div className="feedbackArea">
							{ strongFeedback }
							{ weakFeedback }
						</div>
					</CSSTransition>
				);
			} else if (this.state.analysis == null) {
				var spinner = <Spinner placeholder={ true }/>	
			}
		}
		return (
			<div className="quizAnalysisDisplay">
	        	<TransitionGroup>
					{ this.renderOwlfonso() }
				</TransitionGroup>
	        	<TransitionGroup>
					{ content }
				</TransitionGroup>
				{ spinner }
				<div className="hiddenElement" ref=">_999">
					{ this.buildReactionFeedback() }
				</div>
			</div>
		)
	}

	componentDidMount() {
		this.loadEvaluationDetails()
	}

	////////////////
	////////////
	////////
	////
	// LOAD DATA

	loadEvaluationDetails() {
		CurrentUser.api().getQuiz(this.props.quiz.id,{"embed":"quiz.answers,answer.evaluation_details,answer.meta_data"},$wr.apiHandler(function(response) {
			var quiz = response["quiz"];

			if (quiz) {
				var answers = _.reject(quiz.answers, x => x.question_type == "fill-in-the-blank-question");

				if (answers && (answers.length > 0) && answers[0].evaluation_details) {
					this.setState({ answers }, this.buildEvaluation);
				}
			}

		}.bind(this)))
		this.removeOwlfonso()
	}
	isEvaluationValid(evaluation) {
		if (!(evaluation && evaluation.filtering && evaluation.polarizing && evaluation.corrected_answer)) {
			return false;
		}
		return true;
	}
	buildEvaluation() {
		var filters = {}
		var breakdown = {}
		
		var validation = _.map(this.state.answers, (answer,i) => {
			if (!answer.filtering) {
				this.state.answers[i].evaluation_details['filtering'] = []
			}
			return this.isEvaluationValid(answer.evaluation_details)
		})
		if (validation.includes(false)) {
			this.setState({analysis: false})
			return;
		}
		// GATHER SCORES FOR EACH ELIGIBLE POST QUIZ FEEDBACK KEYS
		_.each(this.state.answers, (answer,i) => {
			if (_.keys(answer.evaluation_details.filtering).length > 0 ) {
				filters[i] = 0
			} else {
				filters[i] = 1
				if (answer.evaluation_details.polarizing != undefined) {
					_.each(answer.evaluation_details.polarizing, (rating, key) => {
						if (AutograderDisplayConfig.isLeafPostQuizFeedback(key)) {
							if (breakdown[key] == undefined) {
								breakdown[key] = {}
							}
							breakdown[key][i] = AutograderDisplayConfig.leafValueToScore(rating.value)
						}
					})
				}
			}
		})
		// ONLY KEEP THE LOWEST SCORE (FRENCH SCORING)
		var analysis = {"Strengths":[], "Weaknesses":[]}
		var examples = {}

		function activeTagging(polarizerkey, answerDetails) {

			if (answerDetails && answerDetails.polarizing && answerDetails.polarizing[polarizerkey] != undefined) {
				var tags = answerDetails.polarizing[polarizerkey].tags || []
				var activeTags = {}
				_.each(tags, (tag, key) => {
					if (activeTags[key] == undefined) {
						activeTags[key] = []
					}
					activeTags[key].push(tag)
				})

				_.each(activeTags, (key) => {
					if (!AutograderDisplayConfig.isDisplayTag(key)) {
						delete activeTags[key];
					}
				});

				return activeTags;
			} else {
				return {};
			}
		}

		// ASSIGN FEEDBACK FOR FILTERS
		if (_.keys(filters).length > 0) {
			var targetIndex = _.values(filters).indexOf(0)
			if (targetIndex > -1) {
				targetIndex = _.keys(filters)[targetIndex]
				var item = AutograderDisplayConfig.getFilterPostQuizFeedback("REQUIREMENT-MINIMUM_LENGTH",false)
				item["example"] = {tags: {},
									corrected_answer:this.state.answers[targetIndex].evaluation_details.corrected_answer,
									question_text: this.state.answers[targetIndex].question_text}
				analysis["Weaknesses"].push(item)
			}
		}

		// ASSIGN FEEDBACK FOR POLARIZER
		_.each(breakdown, (scores, key) => {
			var minScore = Math.min.apply(null, _.values(scores))
			var targetIndex = _.values(scores).indexOf(minScore)
			targetIndex = _.keys(scores)[targetIndex]
			var tags = activeTagging(key, this.state.answers[targetIndex].evaluation_details)
	
			if (minScore > 3) {
				var category = "Strengths"
				var item = AutograderDisplayConfig.getLeafPostQuizFeedback(key,true)
			} else {
				var category = "Weaknesses"
				var item = AutograderDisplayConfig.getLeafPostQuizFeedback(key,false)
			}
			item["example"] = {tags: tags, 
								corrected_answer:this.state.answers[targetIndex].evaluation_details.corrected_answer,
								question_text: this.state.answers[targetIndex].question_text}
			analysis[category].push(item)
		})

		this.setState({analysis: analysis})

	}
}

function pickTagColors(tagging) {
	var tagToColors = {};
	_.each(_.sortBy(_.keys(tagging)), (key, index) => {
		var hasSpans = _.any(tagging[key], (tag) => "spans" in tag);
		if (hasSpans) {
			tagToColors[key] = AUTOGRADER_COLOR_LIST[index % AUTOGRADER_COLOR_LIST.length]			
		}
	})

	return tagToColors;
}

var AUTOGRADER_COLOR_LIST = ["#96dafe", "#a0e881", "#ffcbb3", "#cfadec", "#f2de7f",
	"#c8ecff", "#c0f2aa", "#faaf88", "#fff864"]
var SPELLING = 'Spelling'

QuizAnalysisDisplay.propTypes = StrictPropTypes({
	// gold records to display
	quiz: PropTypes.object.isRequired,
	delay: PropTypes.number.isRequired,
	showCoinTable: PropTypes.func
});

module.exports = QuizAnalysisDisplay;



// WEBPACK FOOTER //
// ./modules/components/writing/quizzes/QuizAnalysisDisplay.js